import React from 'react';
const PropertyLoans = () => <div className="service-page"><h1>Property Loans</h1><p>Property loan solutions for home and commercial spaces.</p></div>;
export default PropertyLoans;
